'use client'
import { Flex, HStack, ListItem, StackDivider, UnorderedList, VStack } from '@chakra-ui/react'
import { GrandText } from 'ui'
import { PaymentMethodLogos } from 'storefront-modules/layout/PaymentMethodLogos'
import Image from 'next/image'
import klarnaLogo from '#/src/images/Klarna_Logo.png'
import sveaLogoImg from '#/src/images/svea_logo.png'
import qliroLogoImg from '#/src/images/qliro_logo.png'
import { useTranslations } from 'next-intl'
import useAppConfig from '#/src/custom/hooks/useAppConfig'

const CustomProductDelivery = () => {
  const t = useTranslations('delivery.CustomProductDelivery')
  const keys = ['yearsOfService', 'showRoomSize', 'personalService'] as const
  const appConfig = useAppConfig()

  const PaymentProviderInfo = () => {
    // Merchant-curated method marks win over the per-provider badge below, which stays
    // as the fallback for stores that have not configured any.
    const methodLogos = appConfig.paymentMethodLogos

    if (
      methodLogos?.productPage?.methods?.length ||
      methodLogos?.productPage?.combinedImageUrl ||
      methodLogos?.productPage?.combinedPreset
    ) {
      return <PaymentMethodLogos config={methodLogos.productPage} />
    }

    switch (appConfig.paymentProviderConfig?.providerName ?? 'KLARNA') {
      case 'KLARNA':
      case 'NEXI':
        return (
          <VStack alignItems="flex-start" flex={1} p={2}>
            <GrandText>{t('payAfterDelivery')}</GrandText>
            <Flex justifyContent="center" w="80%">
              <Image alt="Klarna" src={klarnaLogo} title="klarna" />
            </Flex>
          </VStack>
        )
      case 'SVEA':
        return (
          <VStack alignItems="flex-start" flex={1} p={2}>
            <Image alt="Svea payment methods" src={sveaLogoImg} />
          </VStack>
        )
      // Briqpay is an orchestrator — which methods a shopper sees comes from the Briqpay
      // portal, so there is no single logo to show here.
      case 'BRIQPAY':
        return null
      // todo: add LEDYER info
      case 'LEDYER':
        return <>LEDYER info</>
      case 'QLIRO':
        return (
          <VStack alignItems="flex-start" flex={1} p={2}>
            <Image alt="Qliro" src={qliroLogoImg} style={{ maxWidth: '200px' }} />
          </VStack>
        )
    }
  }

  return (
    <VStack>
      <HStack divider={<StackDivider />}>
        <PaymentProviderInfo />

        <UnorderedList flex={1} fontSize="xs" p={2}>
          {keys.map((key) => (
            <ListItem key={key}>{t(`listItems.${key}`)}</ListItem>
          ))}
        </UnorderedList>
      </HStack>
    </VStack>
  )
}

export default CustomProductDelivery
